module.exports = __webpack_public_path__ + "img/banner_background.73578c9.png";